<template>
  <div class="mensaje">
    <h2 class="mensaje__titulo titulo-h2">Acceso Temporal</h2>
    <div class="mensaje__mensaje">
      <span class="mensaje__texto" v-html="contenido"></span>
    </div>
    <i class="mensaje__icono" :class="'mensaje__icono-emo-happy'" />   
    <div class="mensaje__boton">
      <div class="form__group">
        <a class="waves-effect waves-light m-btn form-fields__navegacion-der" tabindex="0" @click="registro()">Empezar</a>
      </div> 
    </div>   
  </div>    
</template>

<script>
export default {
  computed:{
    contenido(){
      return 'Te hemos permitido el acceso durante 30 minutos. Te invitamos a que te registres o inicies sesión si ya tienes cuenta, para poder disfrutar de una conexión ¡Ilimitada!'
    }
  },
  methods: {
    registro() {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>